export default "__VITE_ASSET__CTeBw0ax__"